import cn from 'classnames';
import { useEffect, useState } from 'react';
import { CommentSection } from 'react-comments-section';
import 'react-comments-section/dist/index.css';
import { useSelector } from 'react-redux';
import PostingsApi from '../../../../API/shipment/postings-api';
import comment_blue from '../../../../assets/media/icons/comment-blue.svg';
import comment_grey from '../../../../assets/media/icons/comment-grey.svg';
import profile from '../../../../assets/media/icons/profile.svg';
import { Row } from '../../../../components/Basic/Blocks';
import { Button } from '../../../../components/Basic/Buttons';
import { DropDown, Icon } from '../../../../components/Basic/Elements';
import { TYPE_BUTTONS } from '../../../../constans';
import styles from './styles.module.scss';

const CommentPostingProductBlock = ({
  posting = {},
  offer_id = '',
  fieldFilter,
  onChange = () => { },
  width = '200px',
  key_mapping = 'offer_id',
  isFilter = true,
  isSmall = false,
}) => {
  const user = useSelector((store) => store.user);
  const userAvatars = useSelector((store) => store.ui.users_avatars);

  const [open, setOpen] = useState(false);
  const [comment_data, setCommentData] = useState([]);

  let [data, setData] = useState([]);

  useEffect(() => { }, [data?.history?.length]);

  const findComment = (order) => {
    let comments = isFilter
      ? order.history?.filter(
        (item) =>
          (fieldFilter ? item.field === fieldFilter : (
            (item.field === 'comment' || item.field === 'comment_checkup' || key_mapping === 'history_id'))) &&
            offer_id === item[key_mapping],
      ) || []
      : order.history || [];

    let d = comments
      .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
      .map((comment) => ({
        userId: comment.user,
        comId: comment._id,
        fullName: comment.user,
        text: comment.value,
        avatarUrl: userAvatars[comment.user] || profile,
        timestamp: comment.date,
        replies: [],
      }))
      .filter((comment) => comment.text.length > 0);
    setCommentData(d);
  };
  const onChangeProductHistory = async (historyElementId, action = undefined, value) => {
    await PostingsApi.changeHistoryPosting({ data: { postingNumber: posting.posting_number, historyElementId, value, action } }).then(
      (r) => {
        findComment(r.posting);
      },
    );
  };

  let addComment = (new_comment) => {
    setCommentData([new_comment, ...comment_data]);
    onChange(new_comment.text);
  };

  let onEdit = (comment) => {
    onChangeProductHistory(comment.comId, 'change', comment.text);
  };
  let onDelete = (comment) => {
    onChangeProductHistory(comment.comIdToDelete, 'delete');
  };

  const customNoComment = () => <div className="no-com">Без комментариев</div>;

  useEffect(() => {
    var elements = document.getElementsByClassName('postBtn'); // или:
    if (elements[0]) {
      elements[0].textContent = 'Отправить';
    }
  }, [open]);

  useEffect(() => {
    findComment(posting, offer_id);
  }, [posting.history?.length]);
  return (
    <div
      className={cn(styles.comment_wrapper, !comment_data[0]?.text.length && styles.comment_wrapper_empty)}
      style={isSmall ? { width: '40px' } : { width }}
      onClick={() => setOpen(true)}
    >
      <div
        onClick={() => setOpen(true)}
        style={{ minWidth: '0' }}
        className={cn(styles.name, !comment_data[0]?.text.length && !isSmall && styles.name_empty)}
      >
        {isSmall ? (
          <>
            <Icon
              src={comment_data.length > 0 ? comment_blue : comment_grey}
              width={'30px'}
              style={{ cursor: 'pointer' }}
            />
          </>
        ) : (
          <>{comment_data[0]?.text} </>
        )}
      </div>
      {open && (
        <div>
          <DropDown close={() => setOpen(false)} styles={styles.drop_down}>
            <div className={styles.comment_block} style={{ width: '500px' }}>
              <CommentSection
                currentUser={{
                  currentUserId: user.name,
                  currentUserImg: user.avatar || profile,
                  currentUserFullName: user.name,
                }}
                advancedInput={false}
                commentData={comment_data}
                titleStyle={{ display: 'none' }}
                placeHolder="Комментарий..."
                onSubmitAction={(new_comment) => {
                  addComment({ ...new_comment, timestamp: new Date() });
                }}
                // currentData={(d) => console.log(d)}
                customNoComment={() => customNoComment()}
                onEditAction={(comment) => onEdit(comment)}
                onDeleteAction={(comment) => onDelete(comment)}
              />
            </div>
            <Row className={styles.close_button}>
              <Button type={TYPE_BUTTONS.RED} onClick={() => setOpen(false)}>
                Закрыть
              </Button>
            </Row>
          </DropDown>
        </div>
      )}
    </div>
  );
};

export default CommentPostingProductBlock;
